import { render, staticRenderFns } from "./CartList.vue?vue&type=template&id=8475ab9a&"
import script from "./CartList.vue?vue&type=script&lang=js&"
export * from "./CartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports